export default __webpack_public_path__ + "static/media/icon-renda.5c06861c.svg";